(() => {
  const SELECTOR = '[data-ag-homepage-intro-video]';
  const observers = new WeakMap();

  const init = (media) => {
    if (!(media instanceof HTMLElement) || media.dataset.agHomepageIntroInit === 'true') return;
    media.dataset.agHomepageIntroInit = 'true';

    if (typeof IntersectionObserver === 'undefined') {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) media.loadContent?.(false);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      if (entry.isIntersecting && !media.hasAttribute('loaded')) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        media.loadContent?.(false);
      }

      const video = media.querySelector('video');
      if (!(video instanceof HTMLVideoElement)) return;
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    }, { rootMargin: '300px 0px', threshold: 0.05 });

    observer.observe(media);
    observers.set(media, observer);
  };

  const initAll = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches(SELECTOR)) init(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    const mediaItems = event.target.matches(SELECTOR)
      ? [event.target]
      : Array.from(event.target.querySelectorAll(SELECTOR));
    mediaItems.forEach((media) => {
      observers.get(media)?.disconnect();
      observers.delete(media);
      media.dataset.agHomepageIntroInit = 'false';
    });
  });
})();
